//import { CountDetailsDto, CountDetailsDtoImpl } from './countdetailsdto';
//import { CountSearchDetailsDtoImpl } from './countsearchdetails';
import { SpecificSearchToneDto, SpecificSearchToneDtoImpl } from './specificsearchtonedto';
//import { ToneDetailsDto, ToneDetailsDtoImpl } from './tonedetailsdto';
import { ToneDto, ToneDtoImpl } from '../tonedto';
import { CountSearchDetailsDtoImpl } from './countsearchdetails';
import { NoDataException } from '../../../utils/exceptions/nodataexistsexception';
import { DateFormat } from '../../../ui/toolkit/dateformat/dateformat';
import { BaseContext } from '../../../utils/basecontext';

export class SpecificSearchToneBuilder {
    constructor(private specificSearchTone: any, private context: BaseContext) {
        if(specificSearchTone === undefined)
        {
            throw new NoDataException("Specific search data doesnt exists");
        }
    }

    buildAll(): SpecificSearchToneDto {
        return this.parseSpecificSearchToneDetailsResponse();
    }

    private parseSpecificSearchToneDetailsResponse(): SpecificSearchToneDto {
        let specificSearchToneDto = new SpecificSearchToneDtoImpl();

         let countDetailsDto = null;
        let countSearchDetailsDto = new CountSearchDetailsDtoImpl();
        
        /* let listOfAlbumDetails: CountDetailsDto[] = [];
        this.specificSearchTone.countList.CountSearchDetails.albumDetailList.CountDetails.forEach((countDetailAlbum: any) => {
            countDetailsDto = new CountDetailsDtoImpl();
            countDetailsDto.setMatchedParam(countDetailAlbum.matchedParam);
            countDetailsDto.setCount(countDetailAlbum.count);
            listOfAlbumDetails.push(countDetailsDto);
        });
        countSearchDetailsDto.setAlbumDetailList(listOfAlbumDetails); */
        
        let listOfSong: ToneDto[] = [];
        let listOfArtistDetails: ToneDto[] = [];
        let listOfTone: ToneDto[] = [];
        if(this.specificSearchTone.countList !== undefined && 
            this.specificSearchTone.countList.artistDetailList !== undefined)
        {
           this.specificSearchTone.countList.artistDetailList.forEach((countDetailArtist: any, index: number) => {
             countDetailsDto = new ToneDtoImpl();
             /* countDetailsDto.setMatchedParam(countDetailArtist.matchedParam);
             countDetailsDto.setCount(countDetailArtist.count); */
            countDetailsDto.setId(String(index));
            countDetailsDto.setArtistName(countDetailArtist.matchedParam);
            // countDetailsDto.setCount(countDetailArtist.count);
            listOfArtistDetails.push(countDetailsDto);
           });
        }
        countSearchDetailsDto.setArtistDetailList(listOfArtistDetails);
        specificSearchToneDto.setCountList(countSearchDetailsDto);

        if(this.specificSearchTone.songList !== undefined)
        {
            let toneDetailsDto = null;

            this.specificSearchTone.songList.forEach((toneDetailForSong : any)=>{
                toneDetailsDto = new ToneDtoImpl();
                toneDetailsDto.setId(toneDetailForSong.toneId);
                //toneDetailsDto.setToneName(toneDetailForSong.toneName);
                toneDetailsDto.setToneUrl(toneDetailForSong.toneIdStreamingUrl);
                //toneDetailsDto.setArtistName(toneDetailForSong.artistName);
                toneDetailsDto.setImgPath(toneDetailForSong.toneIdpreviewImageUrl);
                toneDetailsDto.setPrice(Number(toneDetailForSong.price).toFixed(2));
                toneDetailsDto.setCategoryId(toneDetailForSong.categoryId);
                toneDetailsDto.setLikeCount(toneDetailForSong.likeCount);
                toneDetailsDto.setBaseCategoryId(toneDetailForSong.baseCategoryId);
    
                listOfSong.push(toneDetailsDto);
            });
        }
        specificSearchToneDto.setSongList(listOfSong);
       
        if(this.specificSearchTone.toneList !== undefined)
        {
            let toneDetailsDto = null;
           
            this.specificSearchTone.toneList.forEach((toneDetailForTone : any)=>{
                toneDetailsDto = new ToneDtoImpl();
                toneDetailsDto.setId(toneDetailForTone.toneId);
                toneDetailsDto.setToneName(toneDetailForTone.toneName);
                toneDetailsDto.setToneUrl(toneDetailForTone.toneIdStreamingUrl);
                toneDetailsDto.setArtistName(toneDetailForTone.artistName);
                toneDetailsDto.setImgPath(toneDetailForTone.toneIdpreviewImageUrl);
                toneDetailsDto.setPrice(Number(toneDetailForTone.price).toFixed(2));
                toneDetailsDto.setCategoryId(toneDetailForTone.categoryId);
                toneDetailsDto.setLikeCount(toneDetailForTone.likeCount);
                toneDetailsDto.setExpirydate(DateFormat.formatExpiryDate(toneDetailForTone.expiryDate, this.context));
                toneDetailsDto.setBaseCategoryId(toneDetailForTone.baseCategoryId);
    
                listOfTone.push(toneDetailsDto);
            });
        }
        specificSearchToneDto.setToneList(listOfTone);
        
        
        return specificSearchToneDto;
    }
}




// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/specificsearchtone/specificsearchtonebuilder.ts